import { render, staticRenderFns } from "./debit_note.vue?vue&type=template&id=159b87a6&scoped=true"
import script from "./debit_note.vue?vue&type=script&lang=js"
export * from "./debit_note.vue?vue&type=script&lang=js"
import style0 from "./debit_note.vue?vue&type=style&index=0&id=159b87a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b87a6",
  null
  
)

export default component.exports